export enum FamilyGuideContent {
	NUDITY = "NUDITY",
	VIOLENCE = "VIOLENCE",
	OBSCENITY = "OBSCENITY",
	ALCOHOL_AND_CIGARETTES = "ALCOHOL_AND_CIGARETTES",
	SCARY_SCENES = "SCARY_SCENES",
}

export const FamilyGuideContentOptions = [
	{ value: FamilyGuideContent.NUDITY, label: "برهنگی" },
	{ value: FamilyGuideContent.VIOLENCE, label: "خشونت" },
	{ value: FamilyGuideContent.OBSCENITY, label: "فحاشی" },
	{ value: FamilyGuideContent.ALCOHOL_AND_CIGARETTES, label: "الکل و سیگار" },
	{ value: FamilyGuideContent.SCARY_SCENES, label: "صحنه های ترسناک" },
] as const;

export function getFamilyContentOption(key: string) {
  const val = (FamilyGuideContent as any)[key];
  return FamilyGuideContentOptions.find(o => o.value === val);
}
